var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wtw-container store-list-container clearfix" },
    _vm._l(_vm.options, function(option) {
      return _c(
        "div",
        {
          staticClass: "option button full-width outline",
          class: {
            active:
              _vm.optionActive(option.product_option_value_id) || _vm.allActive
          },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.toggleOption(option.product_option_value_id)
            }
          }
        },
        [_c("img", { attrs: { src: option.product_option_value_image_url } })]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cfda2cd6", { render: render, staticRenderFns: staticRenderFns })
  }
}